import { useTranslation } from "react-i18next"
import BusinessUnitDeleteModal from "./BusinessUnitDeleteModal"


const BusinessUnitDeleteModaButton = ({
    businessUnitInfo,
    onDelete = () => { }
}) => {

    const [t] = useTranslation("global")
    const modalId = `delete${businessUnitInfo.businessUnit.code}`

    return (
        <>
            <button className="btn btn-outline-danger mx-2" data-bs-toggle="modal" data-bs-target={`#${modalId}`}><i className="fa-solid fa-trash"></i> {t("action.delete")}</button>
            <BusinessUnitDeleteModal modalId={modalId} businessUnitInfo={businessUnitInfo} onDelete={onDelete} />
        </>
    )

}

export default BusinessUnitDeleteModaButton